export function getIPScopeListingDatatableConfig() {
    return {
        dom: 'Bfrtip',
        columns: [
            { 'data': 'networkIpRanges', 'width': '50%','title': 'Network IP Ranges' },
            { 'data': 'gateway', 'width': '50%', 'title': 'Gateway' },
            { 'data': 'gateway', 'width': '50%', 'title': 'Prefix Length' }

        ],
        columnDefs: [
            {
                'targets': [0] ,
                'mRender': function (data, type, row) {
                    let value: string = '';
                    if (row) {
                        if (row && row.networkIpRanges) {
                            row.networkIpRanges.map(function(item, index: number){
                            if (index !== 0) {
                                value += '<br>';
                            }
                            value += item.startAddress + ' - ' + item.endAddress;
                            });
                            return value;
                        } else {
                            return '';
                        }
                    }
                    return '';
                }
            },
            {
                'targets': [1] ,
                'mRender': function (data, type, row) {
                    if (row) {
                        let value: string = row.gateway ? row.gateway : '';
                        return value;
                    } else {
                        return '';
                    }
                }
            },
            {
                'targets': [2] ,
                'mRender': function (data, type, row) {
                    if (row) {
                        let value: string = row.prefixLength;
                        return value;
                    } else {
                        return '';
                    }
                }
            },


        ],
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': 'Please add IP Scopes for the Network',
            'sInfoEmpty': ''
        },
        'scrollY': '50vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[0, 'desc']],
        'rowCallback': function (row, data) {
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/dialogs/ipscope.dt.config.ts